import { render } from "./TitanIndex.vue?vue&type=template&id=b38e3a4c&scoped=true"
import script from "./TitanIndex.vue?vue&type=script&lang=js"
export * from "./TitanIndex.vue?vue&type=script&lang=js"

import "./TitanIndex.vue?vue&type=style&index=0&id=b38e3a4c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b38e3a4c"

export default script